import { Checkbox, Form, Input, Select } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { FC, useCallback, useEffect, useMemo, useState } from "react";
import OrganizationSelect from "./OrganizationSelect";
import { useFetchOrgs, useFetchOrgsNode } from "@lhd/hooks";
import { ERRORS_MESSAGE, QUERY_NAME, SERVICES } from "@lhd/constants";
import { getCompanyId } from "@lhd/utility";
import axios from "@lhd/libs/axios";
import { flatMapDeep, pick } from "lodash";
import { OrgNode } from "types/orgNode.type";
export type ModelNameType =
  | "organization"
  | "division"
  | "branch"
  | "department"
  | "worker";

type PropsType = {
  form: FormInstance;
  modelName: ModelNameType;
  getFieldClassName?: (name: string) => string;
};

type SelectionType = {
  label: string;
  id: string;
};

const OrganizationSelectionSetting: FC<PropsType> = ({
  form,
  modelName = "organization",
  getFieldClassName,
}) => {
  const presetTree = Form.useWatch(
    ["item_config_data", `preset_${modelName}`],
    form,
  );
  const [orgNodes, setOrgNodes] = useState<any[]>();
  const { data: listOrg } = useFetchOrgs();
  const orgId = listOrg?.data?.find(
    (org) =>
      org.org_type === (modelName === "organization" ? "chairman" : modelName),
  )?.id;
  const flattenDeepArray: any = useCallback((originalArray: any) => {
    return flatMapDeep(originalArray, (item) => {
      const transformedItem = pick(item, ["id", "name"]);
      const children = item.children || [];

      return [transformedItem, ...flattenDeepArray(children)];
    });
  }, []);

  const optionSelect =
    modelName === "worker" ? orgNodes : flattenDeepArray(orgNodes);
  useEffect(() => {
    if (orgId) {
      axios({
        method: "get",
        url: SERVICES.ORG_NODES,
        params: {
          page: 1,
          per_page: 9999,
          offset: 0,
          "q[org_id_eq]": orgId,
          "q[company_id_eq]": getCompanyId(),
        },
      }).then((res) => {
        setOrgNodes(res.data);
      });
    }
  }, [orgId]);

  useEffect(() => {
    if (modelName === "worker") {
      axios({
        method: "get",
        url: SERVICES.WORKERS,
        params: {
          page: 1,
          per_page: 10000,
          "q[company_id_eq]": getCompanyId(),
        },
      }).then((res) => setOrgNodes(res.data));
    }
  }, [modelName]);

  const presetName = useMemo(() => {
    switch (modelName) {
      case "organization":
        return "プリセット組織";
      case "division":
        return "プリセット部署";
      case "branch":
        return "プリセット支店";
      case "department":
        return "プリセット部門";
      case "worker":
        return "社員プリセット";
      default:
        `Preset ${modelName}`;
    }
  }, [modelName]);
  const defaultValue = form
    .getFieldValue(["item_config_data", `default_${modelName}s`])
    ?.map((selection: SelectionType) => selection.id);
  return (
    <>
      <Form.Item
        label="フィールド名"
        name="name"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        className={`${getFieldClassName?.("name")}`}
      >
        <Input />
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_hide_name"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>フィールド名を表示しない</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name="is_required_field"
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>必須項目にする</Checkbox>
      </Form.Item>
      <Form.Item
        valuePropName="checked"
        name={["item_config_data", `preset_${modelName}`]}
        style={{ marginBottom: "0.5rem" }}
      >
        <Checkbox>{presetName}</Checkbox>
      </Form.Item>
      {presetTree && (
        <div style={{ marginBottom: "1rem" }}>
          <OrganizationSelect
            form={form}
            watchName={`preset_${modelName}s`}
            modelName={modelName}
          />
        </div>
      )}
      <div>デフォルト値</div>
      {/* <OrganizationSelect
        form={form}
        watchName={`default_${modelName}s`}
        modelName={modelName}
      /> */}
      <Form.Item hidden name={["item_config_data", `default_${modelName}s`]} />
      <Select
        defaultValue={defaultValue}
        filterOption={(input, option) => {
          return (option?.label as string)
            .toLowerCase()
            ?.includes(input.toLowerCase());
        }}
        mode="multiple"
        allowClear
        showSearch
        style={{ width: 300 }}
        placeholder="組織を入力ください"
        onChange={(ids) => {
          const v = ids.map((id: number) => {
            const org = orgNodes?.find((org) => org.id == id);
            return {
              id,
              name: orgId ? org?.name : `${org.full_name}`,
            };
          });
          form.setFieldValue(["item_config_data", `default_${modelName}s`], v);
        }}
        options={optionSelect?.map((org: OrgNode) => {
          return {
            label: orgId ? org?.name : `${org.full_name}`,
            value: org?.id,
          };
        })}
      />
      <Form.Item
        label="フィルードコード"
        name="field_code"
        rules={[{ required: true, message: ERRORS_MESSAGE.REQUIRED }]}
        style={{ marginTop: 16 }}
        className={`${getFieldClassName?.("field_code")}`}
      >
        <Input />
      </Form.Item>
    </>
  );
};

export default OrganizationSelectionSetting;
